import { Col, Row, Container, Button, Form } from "react-bootstrap";

import { FaTrashAlt } from "react-icons/fa";

const NewProgram = ({ id, title, description, img, deleteItem }) => {
  return (
    <Row className="pt-4">
      <Col className="rounded shadow bg-white">
        <Row className="py-3">
          <Col md={3}>
            <img src={img} alt="img" className="img-fluid rounded" />
          </Col>
          <Col md={7}>
            <h6 className="mb-0">{title}</h6>
            <p className="txt12">{description}</p>
          </Col>
          <Col md={1}>
            <FaTrashAlt size="14px" className="m-2" onClick={() => deleteItem(id)} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Form className="forms-limber pb-3">
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>How many times a week the exercise will be done?</Form.Label>
                <Form.Control type="text" placeholder="7 x weekly" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>How many times a day on those days?</Form.Label>
                <Form.Control type="text" placeholder="1 x daily" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>How many sets on each time?</Form.Label>
                <Form.Control type="text" placeholder="3 x set" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>How many reps on each set?</Form.Label>
                <Form.Control type="text" placeholder="10 x reps" />
              </Form.Group>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default NewProgram;
